import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import search from '../../assets/home-images/search.png';
import downarrow from '../../assets/home-images/downarrow.png';
import Navbar from "../common-component/navbar/Navbar";



const RuleOfUse = () => {

    const [showPopup, setShowPopup] = useState(false);
    const [language, setLanguage] = useState("english");
    const location = useLocation();
    const togglePopup = () => setShowPopup(!showPopup);

    const handleLanguageChange = (lang) => {
        setLanguage(lang);
        setShowPopup(false);
    };
    return (
        <div>
            <Navbar />
            <div className="experience-main-layout">
                <aside className="left-section" dir={language === "arabic" ? "rtl" : "ltr"}>
                    <div className="searchbox">
                        <img src={search} alt="search" />
                        <input type="text" placeholder="Search..." />
                    </div>
                    <div className="left-menu-content">
                        <div
                            className="agreement-contentname"
                            style={{
                                backgroundColor: location.pathname === "/merchantagreement" ? "#ECF3FF" : "transparent"
                            }}
                        >
                            <Link to="/merchantagreement" className="no-underline">
                                <p>Service Provider Agreement</p>
                            </Link>
                        </div>

                        <div
                            className="agreement-contentname"
                            style={{
                                backgroundColor: location.pathname === "/submissionguidelines" ? "#ECF3FF" : "transparent"
                            }}
                        >
                            <Link to="/submissionguidelines" className="no-underline">
                                <p>Submission Guidelines</p>
                            </Link>
                        </div>
                        <div
                            className="agreement-contentname"
                            style={{
                                backgroundColor: location.pathname === "/privacypolicy" ? "#ECF3FF" : "transparent"
                            }}
                        >
                            <Link to="/privacypolicy" className="no-underline">
                                <p>Privacy Policy</p>
                            </Link>
                        </div>

                        <div
                            className="agreement-contentname"
                            style={{
                                backgroundColor: location.pathname === "/termsofuseforusers" ? "#ECF3FF" : "transparent"
                            }}
                        >
                            <Link to="/termsofuseforusers" className="no-underline">
                                <p>Terms Of Use For Users</p>
                            </Link>
                        </div>
                        <div
                            className="agreement-contentname"
                            style={{
                                backgroundColor: location.pathname === "/ruleofuse" ? "#ECF3FF" : "transparent"
                            }}
                        >
                            <Link to="/ruleofuse" className="no-underline">
                                <p>Rule Of Use</p>
                            </Link>
                        </div>

                    </div>
                    <div className="divider-line"></div>
                    <div className="footer-links">
                        <div className="footer-column">
                            <span>About</span>
                            {/* <span>Business Pro</span> */}
                            <div className="content-arrow">
                                <Link to="/merchantagreement" className="privacy-link">
                                    <span>Privacy & Terms</span>
                                    <img src={downarrow} alt="down arrow" />
                                </Link>
                            </div>
                        </div>
                        {/* <div className="footer-column">
                                           <span>Help Center</span>
                                           <span>FAQ</span>
                                           <span>Careers</span>
                                       </div> */}
                        <div className="footer-column">

                            <div className="content-arrow" onClick={togglePopup}>
                                <span className="language-text">
                                    {language === "english" ? "Language" : "اللغة"}
                                </span>
                                <img src={downarrow} alt="down arrow" className="arrow-icon" />

                                {showPopup && (
                                    <div className="language-popup">
                                        <label>
                                            <input
                                                type="radio"
                                                name="language"
                                                value="english"
                                                checked={language === "english"}
                                                onChange={() => handleLanguageChange("english")}
                                            />
                                            English
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="language"
                                                value="arabic"
                                                checked={language === "arabic"}
                                                onChange={() => handleLanguageChange("arabic")}
                                            />
                                            Arabic
                                        </label>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                </aside>

                <main className="merchant-mid-section-container" >
                    <div className="agreement-heading">
                        <h4>
                            Rules of Use Hayat In Application
                        </h4>
                    </div>

                    <div className="merchant-mid-section-body">
                        <div className="agreement-subheading">
                            <h5>
                                Effective as of: Feb 1, 2025
                            </h5>

                            <p>
                                Welcome to the world of Hayat In L.L.C- S.P.C, where carefully curated deals and offers are tailored to meet your needs, ensuring the application's goal of providing you with the best offers and achieving optimal savings percentages.
                            </p>

                            <h5>
                                Hayat In Deals are:
                            </h5>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span>✓</span>
                                    <p>
                                        Vouchers are available 24/7 unless otherwise stated in the terms of a particular deal.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span>✓</span>
                                    <p>
                                        Redemption can be made by a single individual or any number of people in a group.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span>✓</span>
                                    <p>
                                        Some Vouchers are limited to the number of people, for example (up to one offer for two people, two offers for four people, and three offers for six people or more).
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span>✓</span>
                                    <p>
                                        Before requesting the service, notify the merchant of the Voucher and confirm its acceptance.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span>✓</span>
                                    <p>
                                        The voucher must be presented before payment or when requesting the invoice.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span>✓</span>
                                    <p>
                                        Vouchers are not valid when combined with other discount offers, promotions, special menu items, or loyalty/rewards programs.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span>✓</span>
                                    <p>
                                        We disclaim any responsibility if an outlet is temporarily or permanently closed during the validity period of the offer.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span>✓</span>
                                    <p>
                                        In the event of a dispute, the invoice must be settled in accordance with local laws. We will contact the concerned parties to resolve the issue.
                                    </p>
                                </div>
                            </div>

                        </div>

                        <div className="defined-terms">
                            <h6>1.	Rules of Use for Hayat In Deals:</h6>
                            <p>
                                The utilization of all Hayat In Deals is governed by the following Rules of Use, in addition to any terms of use provided with the Deals.
                                Customers are advised to carefully review these Rules before availing any deal.
                            </p>

                            <h5>1.1 Deal Validity:</h5>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        Your subscription is valid for 12 months from the date of your subscription, unless otherwise specified.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        Vouchers remain valid for 24 hours after acquisition unless explicitly stated otherwise.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        Deals can only be redeemed through the service provider that issued them.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        Deals apply solely to the specified items/services and designated location(s) as outlined in the deal.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        Exclusively designed deals cannot be combined with other discount offers, promotions, special deals, or rewards programs.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        In the event of a service provider refusing to honor a Deal, please reach out to Hayat In Customer Service at <a href="mailto:Info@hayatinapp.com" className="email-link">Info@hayatinapp.com</a>.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        Offers do not apply to any additional service charges or taxes.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        Offers are valid seven days a week unless specified on the Offer.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        Offers are not redeemable for cash unless required by law.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        Unauthorized reproduction, resale, or modification of any Offer is strictly prohibited. Offers become invalid if they are resold or exchanged.
                                    </p>
                                </div>
                            </div>

                            <h5>1.2 Redeeming Offers</h5>
                            <p>Claiming offers on your app is a simple process:</p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span>1.</span>
                                    <p>
                                        Choose the desired offer you wish to benefit from on the application.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span>2.</span>
                                    <p>
                                        Click on the "Get Deal" button.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span>3.</span>
                                    <p>
                                        Watch a brief promotional advertisement lasting 15 to 30 seconds.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span>4.</span>
                                    <p>
                                        Upon completing the ad, you will receive a QR code.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span>5.</span>
                                    <p>
                                        Present the QR code to the server before settling the bill.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span>6.</span>
                                    <p>
                                        Upon entering or scanning the QR code, the offer will be redeemed, and the corresponding item or service will be deducted from your bill.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span>7.</span>
                                    <p>
                                        To redeem more offers, simply repeat the same process.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span>8.</span>
                                    <p>
                                        The number of offers that can be used at the same visit varies from one merchant to another (please review the terms of use for each merchant).
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span>9.</span>
                                    <p>
                                        For added convenience, acquire the voucher before your visit to mitigate any potential technical issues at the service location (the voucher remains valid for 24 hours from the time of acquisition).
                                    </p>
                                </div>
                            </div>


                            <h5>1.3	Types of Offers Offered</h5>
                            <p>Claiming offers on your app is a simple process:</p>
                            <p>1.	Percentage Discounts:</p>
                            <p>
                                Enjoy percentage discounts on the full value of the provided service. The discount percentage varies, ranging from 10% to 60% and more.
                            </p>
                            <p>2. Buy One Get One Free:</p>
                            <p>
                                Explore the "Buy One Get One Free" offers across a wide spectrum of services,
                                including restaurants, hotels, entertainment, fashion stores, and more.
                            </p>

                            <p>3. Service Bundles:</p>
                            <p>
                                Avail offers where purchasing one service entitles you to receive another
                                service for free. This category encompasses service providers in areas such as
                                barbershops, beauty and skincare centers, car care, beauty and dental clinics,
                                daily services, and more.
                            </p>

                            <h5>1.4 How Do Offers Work? </h5>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span><>a)</></span>
                                    <p>
                                        If The Offer Is a Percentage-Based Discount: the specified percentage
                                        will be deducted from the total amount of the bill.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span><>b)</></span>
                                    <p>
                                        Buy One Get One Free: the applicable item or service will be provided
                                        free of charge upon purchase of the qualifying item or service.
                                    </p>
                                </div>
                            </div>

                            <p>1- Food & Beverages</p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        The "Buy One Get One Free" offer for the main course can be utilized by two people, four people, six people, etc.
                                        For example, you can acquire a main course and enjoy an additional main course for free, opt for one lunch and
                                        receive another lunch at no cost, select one brunch and get another brunch complimentary, or even purchase one
                                        Home Beverage and receive an extra Home Beverage for free.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        The discount will be applied to the lowest-priced item, and both items must belong to the same category as specified in the offer.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        Offers apply exclusively to the item specified in the voucher and are not valid for special events unless explicitly stated in the offer.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        Offers cannot be redeemed for breakfast, starters, side dishes, desserts, or shared platters unless expressly indicated otherwise in the offer.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        Offers are not applicable for delivery or takeaway unless explicitly stated otherwise in the offer.
                                    </p>
                                </div>
                            </div>
                            <p>2- Entertainment:</p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        Before your visit, kindly contact the service provider to inquire about the necessity of reservations.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        The offer requires a minimum of two people for redemption unless specified otherwise.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span><strong>•</strong></span>
                                    <p>
                                        While the voucher contains sufficient information, please note that terms and conditions may apply.
                                    </p>
                                </div>
                            </div>
                            <p>
                                may vary for different activities. It is advisable to contact the service providers for verification of details such as the minimum/maximum number of people, age restrictions, safety guidelines, and any other specific conditions.
                            </p>

                            <p>3- Beauty and Fitness:</p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span>1-</span>
                                    <p>
                                        For one person: Enjoy the complimentary service on your next visit after settling the service fee, ensuring that the subsequent visit occurs within the offer period.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span>2-</span>
                                    <p>
                                        For two people: Both individuals can avail themselves of the offer during the same visit by paying for the service for one person.
                                    </p>
                                </div>
                            </div>

                            <p>4- Hotels </p>
                            <p>
                                Book one night and receive an additional night for free. (Offers cannot be shared or sent to other users)
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>2. Excluded Days in the UAE:</h6>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span>1.</span>
                                    <p>Christmas Eve</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <span>2.</span>
                                    <p>Christmas Day</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <span>3.</span>
                                    <p>New Year's Eve</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <span>4.</span>
                                    <p>New Year's Day</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <span>5.</span>
                                    <p>Eid Al Fitr</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <span>6.</span>
                                    <p>Eid Al Adha</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <span>7.</span>
                                    <p>Valentine's Day</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <span>8.</span>
                                    <p>National Day</p>
                                </div>
                            </div>

                        </div>

                        <div className="defined-terms">
                            <h6>3. Changes to the Terms of Use</h6>
                            <p>
                                We reserve the right to amend and modify these Terms of Use at our discretion, and such revisions will become effective immediately upon posting.
                                It applies to all subsequent access to and use of the Site. The Hayat In Platforms will provide you with notice if a material change occurs in any terms, policies, or supplemental terms of the Hayat In Application that materially affects your rights under these Terms, by sending an email, providing notice through the Hayat In Platforms, or updating the date at the top of these Terms. the conditions.
                                Your continued use of the Site following the posting of updated Terms of Use indicates your acceptance and agreement of the modifications.
                                You are expected to review these terms each time you visit the Site to stay informed of any changes, as it is mandatory for you.
                            </p>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
}


export default RuleOfUse